export default __webpack_public_path__ + "static/media/FavouriteIcon.9a1fcc98.svg";